// extracted by mini-css-extract-plugin
export var bounce = "Footer-module--bounce--8138e";
export var dotMoveLeft = "Footer-module--dot-move-left--0b4f2";
export var dotMoveRight = "Footer-module--dot-move-right--5d85a";
export var footer = "Footer-module--footer--cda47";
export var gradient = "Footer-module--gradient--de489";
export var separatorWidth = "Footer-module--separator-width--337c9";